import type { ReactNode } from 'react';

interface AnalyticsSummaryCardProps {
  label: string;
  value: string;
  subtitle?: string;
  icon: ReactNode;
  color?: 'green' | 'amber' | 'red' | 'default';
}

const colorMap = {
  green: 'text-wt-green-primary',
  amber: 'text-wt-amber-primary',
  red: 'text-wt-red-primary',
  default: 'text-foreground',
};

export function AnalyticsSummaryCard({ label, value, subtitle, icon, color = 'default' }: AnalyticsSummaryCardProps) {
  return (
    <div className="flex-1 rounded-lg border border-border bg-card p-6 space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        <span className="text-muted-foreground">{icon}</span>
      </div>
      <p className={`font-mono text-[28px] font-semibold leading-tight tracking-tight ${colorMap[color]}`}>
        {value}
      </p>
      {subtitle && (
        <p className="text-xs text-muted-foreground font-mono">{subtitle}</p>
      )}
    </div>
  );
}
